// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__11Qj-","fullFrame":"DefaultLayout_fullFrame__kv6Qb","nav":"DefaultLayout_nav__1fRCV","content":"DefaultLayout_content__KXu3E"};